import {
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Stack,
  Typography
} from "@mui/material";
import DescriptionIcon from '@mui/icons-material/Description';
import { RiDownloadCloud2Fill } from "react-icons/ri";
import { gridSizeMdLg6 } from "@/shared";

type Documento = {
  name: string;
  url: string;
};

export type ViewDocumentosCoorporativosPageProps = {
  documentosContractuales: Documento[];
  documentosHabilitantes: Documento[];
};

const cardStyle = {
  p: 2,
  borderRadius: 2,
  border: '1px solid #e0e0e0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 1.5,
  transition: '0.2s',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 24px rgba(0,0,0,0.10)',
    borderColor: '#1976d2',
    backgroundColor: '#fafcff',
  },
};

const docButtonStyle = {
  backgroundColor: '#f1f3f4',
  color: '#333',
  fontWeight: 600,
  justifyContent: 'space-between',
  '&:hover': {
    backgroundColor: '#e0e0e0',
  },
};

export default function ViewDocumentosCoorporativosPage({
  documentosContractuales = [],
  documentosHabilitantes = [],
}: ViewDocumentosCoorporativosPageProps) {


  const openDoc = (url: string) => {
    const link = document.createElement('a');
    link.href = url
    link.target = '_blank';
    link.rel = 'noopener noreferrer',
      document.body.appendChild(link);
    link.click();
    document.body.removeChild(link)
  }

  return (
    <Card
      elevation={0}
      sx={{
        mt: 3,
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        backgroundColor: '#fafafa',
      }}
    >
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
          <DescriptionIcon color="primary" />
          <Typography variant="h6" fontWeight={700}>
            Documentos Cargados
          </Typography>
        </Stack>

        <Divider sx={{ mb: 3 }} />

        {/* CONTENEDOR */}
        <Grid container spacing={2}>

          {/* CONTRACTUALES */}
          <Grid item {...gridSizeMdLg6}>
            <Card sx={cardStyle}>
              <Typography fontWeight={700} textAlign="center">
                Documentos Contractuales
              </Typography>
              {documentosContractuales.length ? (
                <Stack spacing={1} width="100%">
                  {documentosContractuales.map((doc, i) => (
                    <Button
                      key={i}
                      size="small"
                      fullWidth
                      onClick={() => openDoc(doc.url)}
                      endIcon={<RiDownloadCloud2Fill size={22} />}
                      sx={docButtonStyle}
                    >
                      {`Documento ${i + 1}`}
                    </Button>
                  ))}
                </Stack>

              ) : (
                <Typography variant="subtitle2"
                  textAlign={'center'}
                  sx={{ color: 'text.secondary' }}>
                  {'No existen ningun documento'}
                </Typography>
              )}

            </Card>
          </Grid>

          {/* HABILITANTES */}
          <Grid item {...gridSizeMdLg6}>
            <Card sx={cardStyle}>
              <Typography fontWeight={700} textAlign="center">
                Documentos Habilitantes
              </Typography>
              {documentosHabilitantes.length ? (
                <Stack spacing={1} width="100%">
                  {documentosHabilitantes.map((doc, i) => (
                    <Button
                      key={i}
                      size="small"
                      fullWidth
                      onClick={() => openDoc(doc.url)}
                      endIcon={<RiDownloadCloud2Fill size={22} />}
                      sx={docButtonStyle}
                    >
                      {`Documento ${i + 1}`}
                    </Button>
                  ))}
                </Stack>

              ) : (
                <Typography variant="subtitle2" textAlign={'center'} sx={{ color: 'text.secondary' }}>
                  {'No existen ningun documento'}
                </Typography>
              )}

            </Card>
          </Grid>

        </Grid>
      </CardContent>
    </Card>
  );
}